import { render, staticRenderFns } from "./AddressColorCellRenderer.vue?vue&type=template&id=5520cacd&scoped=true&lang=pug&"
import script from "./AddressColorCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./AddressColorCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./AddressColorCellRenderer.vue?vue&type=style&index=0&id=5520cacd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520cacd",
  null
  
)

export default component.exports